import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export const Details = (props) => {
  const {
    children, isActive,
  } = props;
  const detailsVisibilityClassName = isActive ? 'details-hide' : 'details-show';

  return (
    <div className={classNames('collapse-content-details', detailsVisibilityClassName)}>
      {children}
    </div>
  );
};

Details.propTypes = {
  isActive: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
};
